<div class="hr-slide-area">
  <div class="ol-template-back-bar"></div>
  <div class="ol-template-slide-data">
    <div class="slide-data-area">
      <div class="images-area">
        <img
          class="first-image"
          [src]="initialValue.firstImageUrl"
          alt="logo da empresa"
        />
      </div>
      <div class="ol-template-slide-info">
        <div
          class="ol-template-slide-title"
          [innerHTML]="initialValue.title"
        ></div>
        <div
          class="ol-template-slide-description"
          [innerHTML]="initialValue.description"
        ></div>
        <div
          class="ol-template-slide-description"
          [innerHTML]="initialValue.firstNote"
        ></div>
        <div
          class="ol-template-slide-description"
          [innerHTML]="initialValue.secondNote"
        ></div>
        <div *ngIf="acceptanceData" class="digital-acceptance-card">
          <hr-digital-acceptance-card
            *ngIf="acceptanceData?.acceptedAt"
            [fullName]="nomeProfissional"
            [dataAceite]="acceptanceData?.acceptedAt"
            [ipAssinante]="acceptanceData?.ipAddress"
          ></hr-digital-acceptance-card>
        </div>

        <button
          class="hr-button-primary btn-download"
          [ngClass]="{ 'only-button': !acceptanceData?.acceptedAt }"
          [disabled]="isDownloading"
          (click)="downloadPdf()"
        >
          <mat-icon [class.loading]="isDownloading">
            {{ isDownloading ? "autorenew" : "download" }}
          </mat-icon>
          <span class="btn-text">Download da carta oferta</span>
        </button>
      </div>
    </div>
  </div>
</div>

<hr-ol-pdf-acceptance
  style="display: none"
  #olPdfAcceptance
></hr-ol-pdf-acceptance>
